<template>
 <footer class="about-footer">
   <div class="container">
     <div class="footer-main">
       <div class="footer-brand">
         <div class="footer-logo">
           <div class="logo-circle">
             <i class="el-icon-building"></i>
           </div>
           <div class="logo-info">
             <h3>新恒丰咨询</h3>
             <p>XINHENGFENG CONSULTING</p>
           </div>
         </div>
       </div>
       <div class="footer-links-group">
         <div class="footer-link-col">
           <h4>关于我们</h4>
           <ul>
             <li>·集团概览</li>
             <li>·发展历程</li>
             <li>·资质荣誉</li>
             <li>·组织架构</li>
             <li>·企业文化</li>
             <li>·领导风采</li>
             <li>·企业视频</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>服务项目</h4>
           <ul>
             <li>·项目策划及风险管理</li>
             <li>·工程咨询及监理</li>
             <li>·人防工程监理</li>
             <li>·建设管理</li>
             <li>·招标代理</li>
             <li>·造价咨询</li>
             <li>·第三方评估规划咨询</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>新闻中心</h4>
           <ul>
             <li>·企业动态</li>
             <li>·行业资讯</li>
             <li>·政策法规</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>典型案例</h4>
           <ul>
             <li>·国家级奖项项目</li>
             <li>·房屋建筑</li>
             <li>·市政公用工程</li>
             <li>·公益工程</li>
             <li>·电力工程</li>
             <li>·冶煤工程</li>
             <li>·航空航天工程</li>
             <li>·项目管理</li>
             <li>·第三方评估</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>社会责任</h4>
           <ul>
             <li>·保护环境</li>
             <li>·回馈社会</li>
             <li>·服务客户</li>
             <li>·关爱员工</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>招贤纳士</h4>
           <ul>
             <li>·用人理念</li>
             <li>·招聘人才</li>
             <li>·在线简历</li>
           </ul>
         </div>
         <div class="footer-link-col">
           <h4>联系我们</h4>
           <ul>
             <li>·联系方式</li>
             <li>·在线地图</li>
             <li>·在线留言</li>
           </ul>
         </div>
       </div>
       <div class="footer-qr">
         <div class="qr-image">
           <div class="qr-placeholder">
             <i class="el-icon-qrcode"></i>
           </div>
           <p>扫一扫查看公众号</p>
         </div>
       </div>
     </div>
     <div class="footer-bottom-bar">
       <p>Copyright (c) 2002-2020 新恒丰咨询集团有限公司 版权所有 备案号: 豫ICP备20021231号</p>
       <span>技术支持: 吉之浦科技</span>
     </div>
   </div>
 </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
/* ===== Footer ===== */
.about-footer {
  background: #0c1b3b;
  color: #fff;
  padding-top: 60px;
}

.footer-main {
  display: grid;
  grid-template-columns: 220px 1fr 160px;
  gap: 40px;
  padding-bottom: 40px;
}

.footer-brand {
  padding-right: 0;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo-circle {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #1a56db, #3b82f6);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 28px;
    color: #fff;
  }
}

.logo-info {
  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  p {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    letter-spacing: 1.5px;
    line-height: 1.2;
  }
}

.footer-links-group {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 16px;
}

.footer-link-col {
  min-width: 0;

  h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #fff;
    white-space: nowrap;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 11.5px;
      color: rgba(255, 255, 255, 0.6);
      padding: 4px 0;
      cursor: pointer;
      transition: color 0.3s ease;
      line-height: 1.6;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: #fff;
      }
    }
  }
}

.footer-qr {
  text-align: center;
}

.qr-placeholder {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 12px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 70px;
    color: #1a56db;
  }
}

.qr-image p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-bottom-bar {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }

  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }
}
/* ===== 平板端适配 ===== */
@media (max-width: 992px) {
  .footer-main {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-links-group {
    grid-column: 1 / -1;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    order: 3;
  }

  .footer-qr {
    order: 2;
    justify-self: end;
  }

  .qr-image {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .qr-placeholder {
      margin: 0;
      width: 100px;
      height: 100px;

      i {
        font-size: 56px;
      }
    }
  }
}

/* ===== 手机端适配 ===== */
@media (max-width: 768px) {
  .about-footer {
    padding-top: 40px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 30px;
    padding-bottom: 30px;
  }

  .footer-logo {
    justify-content: center;
  }

  .logo-circle {
    width: 48px;
    height: 48px;

    i {
      font-size: 24px;
    }
  }

  .logo-info {
    h3 {
      font-size: 20px;
    }
  }

  .footer-links-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 22px;
  }

  .footer-link-col {
    h4 {
      font-size: 14px;
      margin-bottom: 12px;
    }

    ul li {
      font-size: 12.5px;
      padding: 4px 0;
      white-space: normal;
    }
  }

  .footer-qr {
    justify-self: center;

    .qr-image {
      flex-direction: column;
      gap: 10px;
    }
  }

  .footer-bottom-bar {
    flex-direction: column;
    text-align: center;
    gap: 8px;
    padding: 20px 0;

    p,
    span {
      font-size: 12px;
      line-height: 1.6;
    }
  }
}

/* ===== 小屏手机适配 ===== */
@media (max-width: 480px) {
  .footer-links-group {
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  }

  .footer-link-col {
    text-align: left;

    h4 {
      margin-bottom: 10px;
    }
  }

  .logo-info {
    h3 {
      font-size: 18px;
    }

    p {
      font-size: 10px;
    }
  }
}
</style>
